import { render, staticRenderFns } from "./Kinder.vue?vue&type=template&id=41a243f2&"
import script from "./Kinder.vue?vue&type=script&lang=js&"
export * from "./Kinder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports